// extracted by mini-css-extract-plugin
export default {"logo":"Partner_logo__ysgSB","park":"Partner_park__zTIhi"};